import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { Company } from 'src/app/classes/models';
import { AuthService } from 'src/app/services/auth.service';
import { CompanyService } from 'src/app/services/company.service';
import { GridService } from 'src/app/services/grid.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-clients-grid',
  // templateUrl: './clients-grid.component.html',
  // Point the template url to the base grid url
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    './clients-grid.component.less',
    '../base-grid/base-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClientsGridComponent extends BaseGridComponent implements OnInit {
  constructor(
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService,
    private CompanyService: CompanyService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'Company';
    this.rowModelType = 'serverSide';

    this.additionalQueryData = {
      attributes: ['id']
    };

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.CompanyService.getCompanies(queryObject),
          this.CompanyService.getCompanyCount(countQueryObject)
        ]).subscribe({
          next: ([Companies, companyCount]) => {
            const successObject: { rowData: any[]; rowCount: number } = {
              rowData: Companies,
              rowCount: companyCount
            };

            params.success(successObject);
          },
          error: (error) => {
            console.log(error);
            params.fail();
          }
        });
      }
    };
  }
}
